import SectionProvider from '@builder/sections/SectionProvider'
import moment from 'moment'

export const name = 'Time Item 1'
export const group = 'time'
export const defaultOptions = {
  content: {
    time: {
      type: 'time-mod',
      display: true,
      time: moment(moment().format('YYYY-MM-DD') + ' ' + '23:59').valueOf(),
      timeZone: Intl.DateTimeFormat().resolvedOptions().timeZone,
      size: .8,
      sizing: {
        width: 6,
        counter: 3.5,
        divider: 1.5,
        subtitle: 0.8,
        padding: 3
      }
    }
  },
  customize: {
    layouts: null,
    style: {
      background: {
        background: '#ffffff'
      },
      color: {
        type: 'color-customs',
        color: '#0C226C'
      },
      colorSubtitle: {
        color: '#aeb1b4',
        type: 'color-customs',
        label: 'Subtitle color'
      },
      shadow: {
        shadow: '0px 5px 22px rgba(177, 177, 177, 0.5)'
      },
      dontShow: {
        type: 'checklist-customs',
        label: 'Don\'t Show',
        value: [],
        items: ['Days', 'Hours', 'Minutes', 'Seconds']
      },
      container: {
        type: 'container-customs',
        container: null
      },
      padding: {
        type: 'height-customs',
        sm: {
          top: 20,
          bottom: 20,
          left: 20,
          right: 20
        },
        md: {
          top: 20,
          bottom: 20,
          left: 20,
          right: 20
        },
        lg: {
          top: 20,
          bottom: 20,
          left: 20,
          right: 20
        }
      }
    }
  }
}

export const previews = {
  left: null,
  right: null,
  main: require('@builder/assets/svg/previews/time/main-1.png')
}

export default class Section extends SectionProvider {
  constructor (options = {}) {
    super('TimeItem1', options)

    this.name = name
    this.group = group
    this.defaultOptions = defaultOptions
  }
}
